module.exports = __webpack_public_path__ + "img/2024-12-12d_1.35f04bff.jpg";